const t="sdk_fiat_on_ramp_completed_with_status";export{t as ON_RAMP_COMPLETE_ANALYTICS_EVENT};
